import { render, staticRenderFns } from "./UnauthBaseCard.vue?vue&type=template&id=7fc47f34&scoped=true&"
import script from "./UnauthBaseCard.vue?vue&type=script&lang=js&"
export * from "./UnauthBaseCard.vue?vue&type=script&lang=js&"
import style0 from "./UnauthBaseCard.vue?vue&type=style&index=0&id=7fc47f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc47f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
